import React from "react"
import { Modal, Button, Col, Row, Form } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { BirthdayInput } from "../FormattedInputs/BirthdayInput"
import { parseISO } from "date-fns"

interface EditActiveImageDateProps {
  show: boolean
  activeDate?: string
  inactiveDate?: string
  onCancel: () => void
  onUpdate: (activeDate: Date, inactiveDate: Date) => void
}


interface EditActiveImageDateState {
  activeDate: Date
  inactiveDate?: Date
}

export default class EditActiveImageDate extends React.PureComponent<EditActiveImageDateProps, EditActiveImageDateState> {
  state: EditActiveImageDateState = {
    activeDate: parseISO(this.props.activeDate || ""),
    inactiveDate: parseISO(this.props.inactiveDate || ""),
  }

  activeDate = React.createRef<DatePicker>()
  inactiveDate = React.createRef<DatePicker>()

  render() {
    const { activeDate, inactiveDate } = this.state
    const validActiveDate = !!activeDate
    const validInactiveDate = !!inactiveDate && !!activeDate && activeDate <= inactiveDate
    const canSave = validActiveDate && validInactiveDate
    return (
      <Modal backdrop="static" show={this.props.show} size="xl" className="dark" onHide={this.props.onCancel}>
        <Modal.Header closeButton>
          <Modal.Title className="text-uppercase">Edit Active Image Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Row className="form-group required">
              <Form.Label column lg={2} xs={6} className="text-lg-right" htmlFor="fileName">Active Date</Form.Label>
              <Col lg={4} xs={6}>
                <DatePicker className="form-control"
                  ref={this.activeDate}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  popperPlacement="top-end"
                  minDate={new Date()}
                  selected={this.state.activeDate}
                  enableTabLoop={false}
                  onKeyDown={(e) => { if (this.activeDate && this.activeDate.current && e.key === 'Tab') { this.activeDate.current.setOpen(false) } }}
                  onChange={date => this.setState({ activeDate: date as Date, inactiveDate: undefined })}
                  customInput={<BirthdayInput isInvalid={!validActiveDate} />} />
              </Col>
              <Col xs={12} className="d-lg-none pt-2"></Col>
              <Form.Label column lg={2} xs={6} className="text-lg-right" htmlFor="fileName">Inactive Date</Form.Label>
              <Col lg={4} xs={6}>
                <DatePicker className="form-control"
                  ref={this.inactiveDate}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  popperPlacement="top-end"
                  minDate={this.state.activeDate}
                  selected={this.state.inactiveDate}
                  enableTabLoop={false}
                  onKeyDown={(e) => { if (this.inactiveDate && this.inactiveDate.current && e.key === 'Tab') { this.inactiveDate.current.setOpen(false) } }}
                  onChange={date => this.setState({ inactiveDate: date as Date })}
                  customInput={<BirthdayInput isInvalid={!validInactiveDate} />} />
              </Col>
            </Form.Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onCancel}>Cancel</Button>
          <Button onClick={() => this.props.onUpdate(activeDate, inactiveDate!)} disabled={!canSave} className="ml-1">Finish</Button>
        </Modal.Footer>
      </Modal>)
  }
}
